import { useState, useCallback, useEffect } from "react";
import api from "../../services/api";
import { notifyError, notifySucces } from "../../utils/notifications";
import { IPushPermission, IPendingChange } from "./types";
import { PUSH_PERMISSIONS_STORAGE_KEY } from "../../helpers/hasPushPermission";

const usePushManagement = () => {
  const [data, setData] = useState<IPushPermission[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [pendingChange, setPendingChange] = useState<IPendingChange | null>(
    null
  );

  const fetchPermissions = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get("push_permissions");
      const apiData = Array.isArray(response?.data)
        ? response.data
        : response?.data?.data || [];

      const activeFunctions = apiData.filter((item: IPushPermission) => {
        const active = item?.functionDetails?.active as boolean | number | undefined;
        return active === true || active === 1;
      });

      setData(activeFunctions);

      const cleanToStore = JSON.parse(JSON.stringify({ apiData }));
      sessionStorage.setItem(
        PUSH_PERMISSIONS_STORAGE_KEY,
        JSON.stringify(cleanToStore)
      );
    } catch (err: any) {
      console.error("Erro ao carregar permissões push", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPermissions();
  }, [fetchPermissions]);

  const openConfirmation = (
    record: IPushPermission,
    channel: "push" | "sac",
    checked: boolean
  ) => {
    setPendingChange({
      id: record.id,
      function_name: record.functionDetails?.name || "Desconhecida",
      channel,
      value: checked,
    });
    setIsModalOpen(true);
  };

  const confirmChange = async () => {
    if (!pendingChange) return;

    try {
      setIsSaving(true);
      await api.put("push_permissions/update", {
        id: pendingChange.id,
        channel: pendingChange.channel,
        value: pendingChange.value,
        function_name: pendingChange.function_name,
      });

      notifySucces("Permissão atualizada com sucesso!", true);

      await fetchPermissions();
    } catch (err: any) {
      notifyError("Erro ao atualizar permissão", "", false, true);
    } finally {
      setIsSaving(false);
      setIsModalOpen(false);
      setPendingChange(null);
    }
  };

  const cancelChange = () => {
    setIsModalOpen(false);
    setPendingChange(null);
  };

  return {
    data,
    loading,
    isSaving,
    isModalOpen,
    pendingChange,
    openConfirmation,
    confirmChange,
    cancelChange,
    fetchPermissions,
  };
};

export default usePushManagement;
